export const SET_PAYER = 'payer/SET_PAYER';
